/* Merkliste für Sofa-Konfigurationen.

   Gemerkt wird eine Kombination aus Stoff und Farbe, nicht das Produkt —
   dasselbe Sofa in Cord Glacier und in Velvet Mustard sind zwei Einträge.

   Gespeichert wird im localStorage des Browsers. Ohne Kundenkonto gibt es
   keinen Ort, an dem eine Merkliste serverseitig zu einer Person gehören
   könnte; ein anonymer Serverspeicher brächte nur die Pflicht, personen-
   beziehbare Daten vorzuhalten, ohne dem Kunden etwas zu geben.

   Beide Seiten — der Herzknopf im Viewer und das Symbol in der Kopfzeile —
   arbeiten auf demselben Speicher und hören auf dasselbe Ereignis. */
(function () {
  'use strict';

  var SPEICHER = 'fmnv:favoriten:v1';
  var EREIGNIS = 'fmnv:favoriten';
  var MAX = 60;   // reicht weit über jede echte Merkliste hinaus

  function lesen() {
    try {
      var roh = localStorage.getItem(SPEICHER);
      var liste = roh ? JSON.parse(roh) : [];
      return Array.isArray(liste) ? liste : [];
    } catch (e) {
      // Privater Modus oder voller Speicher — dann eben ohne Merkliste.
      return [];
    }
  }

  function schreiben(liste) {
    try {
      localStorage.setItem(SPEICHER, JSON.stringify(liste.slice(0, MAX)));
    } catch (e) { /* still weiter */ }
    document.dispatchEvent(new CustomEvent(EREIGNIS, { detail: { liste: liste } }));
  }

  /* Meldet Merken und Entfernen an die Kundenereignisse; der Pixel
     „Google Analytics" macht daraus add_to_wishlist bzw.
     fmnv_favorit_entfernt. Ohne Einwilligung verwirft Shopify das Ereignis. */
  function melden(aktion, eintrag) {
    try {
      var sa = window.Shopify && window.Shopify.analytics;
      if (!eintrag || !sa || typeof sa.publish !== 'function') return;
      var titel = String(eintrag.titel || '');
      var bis = titel.lastIndexOf(' in ');
      sa.publish('fmnv:favorit', {
        aktion: aktion,
        produkt: String(eintrag.id || '').split(':')[0],
        produktTitel: bis > 0 ? titel.slice(0, bis) : titel,
        stoff: eintrag.stoff || '',
        farbe: eintrag.farbe || '',
        code: eintrag.code || '',
        sofaVid: eintrag.sofaVid || null,
        anzahl: lesen().length,
      });
    } catch (e) { /* Messung darf die Merkliste nie stören */ }
  }

  var Favoriten = {
    alle: lesen,

    enthaelt: function (id) {
      return lesen().some(function (f) { return f.id === id; });
    },

    /* Legt an oder entfernt und gibt den neuen Zustand zurück. */
    umschalten: function (eintrag) {
      var liste = lesen();
      var i = liste.findIndex(function (f) { return f.id === eintrag.id; });
      if (i >= 0) {
        var alt = liste.splice(i, 1)[0];
        schreiben(liste);
        melden('entfernt', alt);
        return false;
      }
      liste.unshift(eintrag);   // Neuestes zuerst
      schreiben(liste);
      melden('gemerkt', eintrag);
      return true;
    },

    entfernen: function (id) {
      var liste = lesen();
      var alt = liste.find(function (f) { return f.id === id; });
      schreiben(liste.filter(function (f) { return f.id !== id; }));
      if (alt) melden('entfernt', alt);
    },

    anzahl: function () { return lesen().length; },

    /* Meldet sich an und feuert einmal sofort, damit der Aufrufer nicht
       zusätzlich einen Startzustand herstellen muss. */
    beiAenderung: function (fn) {
      document.addEventListener(EREIGNIS, function (e) { fn(e.detail.liste); });
      // Ein zweiter Reiter desselben Browsers ändert die Liste ebenfalls.
      window.addEventListener('storage', function (e) {
        if (e.key === SPEICHER) fn(lesen());
      });
      fn(lesen());
    },
  };

  window.FmnvFavoriten = Favoriten;
})();
